<template>
    <div class="d-none">
        <div class="row mx-1" v-for="market in markets" :key="market.id"
             v-if="finded.includes(market.id) || market.id == 0" v-on:click="selectMarkets(market.id)">
            <div class="col-12 px-1">
                <div class="odd-head" :class="(selectedMarket == market.id) ? 'active' : ''">
                    <div class="head-title"><i :class="market.i" class="pr-3"></i>{{ market.name }}</div>
                    <div class="head-icon">
                        <span v-if="selectedMarket == market.id">
                            <i class="ti-angle-up"></i>
                        </span>
                        <span v-else>
                            <i class="ti-angle-down"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mt-2 mx-1" v-if="odds">
                <div class="col-12 cox px-1" v-for="odd in odds">
                    <template
                            v-if="(odd.layout == 1 || odd.layout == 2 || odd.layout == 3 || odd.layout == 4)">
                        <div class="market-item">
                            <div class="market-wrapper">
                                {{odd.name}}
                            </div>
                            <div class="odd-labels">
                                <div v-for="selection in odd.odd"
                                     class="odd-market text-center">
                                    <span v-tooltip="selection.outcome">{{selection.outcome}}</span>
                                    <a :id="'_odd_'" v-on:click="addBet(selection, {name: odd.name}, match)"
                                       :class="odd.change">
                                        <template v-if="selection.active && selection.odd !== '1.00'">
												<span class="odd text-center">
													{{ selection.odd }}
												</span>
                                        </template>
                                        <template v-if="!selection.active || selection.odd === '1.00'">
                                            <i class="icon-lock"></i>
                                        </template>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="odd.layout > 4">
                        <div class="market-item lineOdd-list">
                            <div class="market-wrapper">
                                {{odd.name}}
                            </div>
                            <div class="odd-labels">
                                <div v-for="selection in odd.odd"
                                     class="odd-market text-center"
                                     :class="(findByKey(selectedOdds, 'oddId', selection.id)) ? 'active' : 'disable' ">
                                    <span v-tooltip="selection.outcome">{{ selection.outcome }}</span>
                                    <a :id="'_odd_'" v-on:click="addBet(selection, {name: odd.name}, match)"
                                       :class="odd.change">
                                        <template v-if="selection.active && selection.odd !== '1.00'">
                                            <span class="odd">
												{{ selection.odd }}
											</span>

                                        </template>
                                        <template v-if="!selection.active || selection.odd === '1.00'">
                                            <i class="icon-lock"></i>
                                        </template>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import extraOdd from "./extraOdd";
    export default {
        name: "oddHead",
        props: ['odds'],
        //components: {extraOdd},
        data() {
            return {
                t: this.$root.t,
                selectedMarket: 0,
                finded: [],
                markets: [
                    {name: 'Tumu', id: 0, i: 'icon-grid'},
                    {name: 'Main', id: 1, i: 'entypo-icon-tv'},
                    {name: 'Fav', id: 111, i: 'entypo-icon-shield'},
                    {name: 'Handikap', id: 17, i: 'entypo-icon-resize-full-screen'},
                    {name: 'Toplam', id: 15, i: 'entypo-icon-code'},
                    {name: '1. Ceyrek', id: 21, i: 'ti-time'},
                    {name: '2. Ceyrek', id: 22, i: 'ti-time'},
                    {name: '3. Ceyrek', id: 23, i: 'ti-time'},
                    {name: '4. Ceyrek', id: 24, i: 'ti-time'},
                    {name: '1. Period', id: 30, i: 'ti-time'},
                    {name: '2. Period', id: 31, i: 'ti-time'},
                    {name: '3. Period', id: 32, i: 'ti-time'},
                    {name: 'İlk yarı', id: 14, i: 'entypo-icon-circular-graph'},
                    {name: 'İkinci yarı', id: 16, i: 'entypo-icon-circle'},
                    {name: 'Korner', id: 2, i: 'entypo-icon-popup'},
                    {name: 'Oyuncu', id: 53, i: 'entypo-icon-user'},
                    {name: 'Oyuncu', id: 100, i: 'entypo-icon-user'},
                    {name: 'Faul', id: 100, i: 'entypo-icon-notification'},
                    {name: 'Taç', id: 100, i: 'entypo-icon-align-vertical-middle'},
                    {name: 'Kart', id: 33, i: 'entypo-icon-documents'},
                    {name: 'Shot', id: 100, i: 'entypo-icon-vinyl'},
                    {name: 'Offside', id: 100, i: 'entypo-icon-flag'},
                    {name: 'Değişiklik', id: 100, i: 'entypo-icon-swap'},
                    {name: 'Top Poz.', id: 100, i: 'entypo-icon-shareable'},
                    {name: 'Diğer', id: 18, i: 'entypo-icon-dots-three-horizontal'},
                ],
            }
        },
        mounted() {
            setTimeout(() => {
                this.findMarkets();
            }, 10);
        },
        methods: {
            findMarkets() {
                for (var key in this.odds) {
                    for (var mx in this.odds[key].markets) {
                        if (this.finded.indexOf(this.odds[key].markets[mx]) == -1) {
                            this.finded.push(this.odds[key].markets[mx]);
                        }
                    }
                }
            },
            selectMarkets(Market) {
                this.selectedMarket = Market;

                //this.$emit('selected', Market);
            }
        }
    }
</script>

<style scoped>
    .odd-head {
        background: #ededed;
        border: 1px solid #ccc;
        display: flex;
    }

    .odd-head.active {
        background: aliceblue;
    }

    .odd-head .head-title {
        font-size: 12px;
        padding-left: 10px;
        line-height: 2;
        justify-content: start;
        flex: 0 0 50%;
    }

    .head-icon {
        display: flex;
        flex: 0 0 50%;
        justify-content: flex-end;
        align-items: center;
        padding-right: 10px;
        float: right;
    }

    .live-tracker {
        border: none;
        width: 100%;
        height: 45vh;
    }

    .odd-loading {
        width: 150px;
        height: 150px;
        margin: auto;
    }

    .market-item {
        display: flex;
        width: 100%;
        font-size: 11px;
        border-bottom: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        background: #fff;
    }

    .lineOdd-header {
        background: #003366 !important;
    }

    .market-item:first-child {
        border-top: 1px solid #ccc;
    }

    .odd-pop-block .col-12:nth-child(2n+1) .market-item {
        background: #ebebeb;
    }

    .market-wrapper {
        flex: 0 0 60%;
        align-items: center;
        line-height: 23px;
        display: flex;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        padding-left: 10px;
        box-sizing: border-box;
        min-height: 30px;
    }

    .odd-labels {
        width: 100%;
    }

    .odd-labels .odd-market {
        width: 33.3%;
        height: 30px;
        float: left;
        font-size: 11px;
        display: flex;
        text-align: left;
        justify-content: center; /* align horizontal */
        align-items: center;
        border-left: 1px solid #ccc;
        padding: 0 10px;
    }

    .odd-labels .odd-list {
        display: inline-flex;
    }

    .odd-labels div span {
        flex: 0 0 50%;
        text-align: left;
        overflow: hidden;
        position: relative;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lineOdd-list .market-wrapper {
        align-items: flex-start;
    }

    .odd-labels a {
        min-width: 37px;
        max-width: 70px;
        border: 1px solid #959595;
        height: 18px;
        font-size: 11px;
        justify-content: center;
        text-align: center;
        display: flex;
        cursor: pointer;
        align-items: center;
        background: #fdfdfd;
        margin-left: 2px;
        color: #000;
        flex: 0 0 50%;
    }

    .odd-labels .active a {
        background: #f64835 !important;
        color: #fff
    }

    .odd-labels .active .odd {
        color: #fff;
    }

    .market-header {
        background: #3e2950;
        font-weight: bold;
        font-size: 14px;
        color: #fff;
    }

    .market-header:hover, .odd-labels .odd:hover {
        background: #ef8107 !important;
    }

    .b-t, .b-r, .b-l, .b-b {
        border-color: #3e2950;
    }

    .color-scheme-dark .market-item .odd-labels div {
        background-image: linear-gradient(180deg, #273048, #303950);
        color: #fff !important;
    }

    .odd-labels .odd, .odd-labels .outcome {
        float: right;
        width: 100%;
        display: block;
        position: relative;

    }

    .odd-labels .odd {
        color: #000;
        font-size: 11px;
        display: contents;
    }

    .color-scheme-dark .odd-labels .odd {
        color: #eee;
    }

    .typcn-arrow-sorted-up {
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+66,ffffff+87,ffffff+87,00e544+88&0+0,1+100 */
        background: -moz-linear-gradient(45deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.66) 66%, rgba(255, 255, 255, 0.87) 87%, rgba(0, 229, 68, 0.88) 88%, rgba(0, 229, 68, 1) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.66) 66%, rgba(255, 255, 255, 0.87) 87%, rgba(0, 229, 68, 0.88) 88%, rgba(0, 229, 68, 1) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.66) 66%, rgba(255, 255, 255, 0.87) 87%, rgba(0, 229, 68, 0.88) 88%, rgba(0, 229, 68, 1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    }

    .typcn-arrow-sorted-down {
        color: red;
    }

    .mandown {
        background: linear-gradient(45deg, rgba(255, 0, 4, 1) 0%, rgba(255, 23, 27, 1) 9%, rgba(255, 26, 30, 0) 10%, rgba(255, 255, 255, 0)) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    }

    .manup {
        background: linear-gradient(45deg, rgba(255, 255, 255, 0) 0%, rgba(25, 181, 59, 0) 90%, rgba(23, 180, 57, 1) 91%, rgba(0, 173, 37, 1) 100%) !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/oddHead.vue